import React from "react";
import "./PrivacyPolicy.css"; // Assuming you have a CSS file for styling

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-page">
      <h1>Privacy Policy</h1>
      <p><strong>Effective Date:</strong> [Insert Date]</p>
      <p><strong>Last Updated:</strong> [Insert Date]</p>
      <p>
        At Priority Pest Defense LLC., we respect your privacy and are committed to protecting the personal and business information you share through Priority Pest Defense LLC., our web-based application for construction trade companies.
      </p>
      <p>This Privacy Policy outlines how we collect, store, use, and share your data.</p>

      <h2>1. Information We Collect</h2>
      <p>When you use Priority Pest Defense LLC., we may collect the following types of information:</p>
      <ul>
        <li><strong>Business Information:</strong> Company name, address, licenses, certifications</li>
        <li><strong>User Information:</strong> Names, email addresses, roles, login credentials</li>
        <li><strong>Employee & Contractor Data:</strong> Contact info, schedules, certifications, time logs</li>
        <li><strong>Vendor Information:</strong> Contact details, service history</li>
        <li><strong>App Usage Data:</strong> Log-in activity, IP addresses, browser/device type</li>
      </ul>
      <p>
        This data is collected to enable core features like scheduling, invoicing, contractor tracking, and record storage.
      </p>

      <h2>2. How We Use Your Information</h2>
      <p>We use the collected data to:</p>
      <ul>
        <li>Provide, operate, and improve the Priority Pest Defense LLC. app</li>
        <li>Manage accounts, send notifications, and support user requests</li>
        <li>Generate work orders, invoices, and proposals</li>
        <li>Maintain secure access and app functionality</li>
      </ul>

      <h2>3. Data Sharing and Integrations</h2>
      <p>We do not sell or rent your data.</p>
      <p>We may share data with third-party services that help us run the app, such as:</p>
      <ul>
        <li>QuickBooks Online, for invoice syncing (if authorized by you)</li>
        <li>Secure cloud hosting providers (e.g., Firebase)</li>
        <li>Customer support or analytics tools</li>
      </ul>
      <p>All third-party services are required to adhere to strict confidentiality and data security standards.</p>

      <h2>4. How We Protect Your Data</h2>
      <p>We use industry-standard security measures to protect your information:</p>
      <ul>
        <li>Encrypted connections (SSL)</li>
        <li>Secure authentication and database storage</li>
        <li>Role-based access control</li>
        <li>Regular backups and security audits</li>
      </ul>
      <p>
        Despite our efforts, no method of data transmission is 100% secure. We encourage you to use strong passwords and manage access carefully.
      </p>

      <h2>5. Your Rights & Choices</h2>
      <p>You have the right to:</p>
      <ul>
        <li>Request access to your data</li>
        <li>Correct or update inaccurate information</li>
        <li>Delete your data permanently</li>
        <li>Opt out of non-essential communications</li>
      </ul>
      <p>To exercise these rights, contact us using the details below.</p>

      <h2>6. Contact Us</h2>
      <p>If you have questions or concerns about this Privacy Policy or your data, please reach out:</p>
      <p>
      Priority Pest Defense LLC.<br />
        Email: Team@prioritypestdefense.com
      </p>
    </div>
  );
};

export default PrivacyPolicy;